import React from 'react';
import ModalWrapper from 'Common/Components/ModalWrapper';
import {
  ModalTitle, Title, BodyText, ModalContent, ButtonsContainer,
  ConfirmButton, CancelButton, Warning, ModalBody
} from './styled';
import useKeyPress from 'Hooks/useKeyPress';

const ModalConfirmation = ({
  handleSubmit, handleClose, entity, count, loading, wrapperTestId, confirmButtonTestId, cancelButtonTestId
}) => {
  const upperCaseTitle = entity.charAt(0).toUpperCase() + entity.slice(1);

  useKeyPress(() => {
    if (handleSubmit) handleSubmit();
  }, ['Enter']);

  useKeyPress(() => {
    if (handleClose) handleClose();
  }, ['Escape']);

  return (
    <ModalWrapper>
      <ModalContent data-testid={ wrapperTestId }>
        <ModalTitle>
          <Warning />
          <Title>{`Delete ${upperCaseTitle}(s)`}</Title>
        </ModalTitle>
        <ModalBody>
          <BodyText>{`You’re deleting ${count} ${upperCaseTitle}(s). This action cannot be undone. Are you sure you want to proceed?`}</BodyText>
        </ModalBody>
        <ButtonsContainer>
          <CancelButton onClick={ handleClose } data-testid={ cancelButtonTestId }>
            Cancel
          </CancelButton>
          <ConfirmButton onClick={ handleSubmit } disabled={ loading } data-testid={ confirmButtonTestId }>
            Delete
          </ConfirmButton>
        </ButtonsContainer>
      </ModalContent>
    </ModalWrapper>
  );
};

export default ModalConfirmation;
